"use strict";
var __create = Object.create;
var __defProp = Object.defineProperty;
var __getOwnPropDesc = Object.getOwnPropertyDescriptor;
var __getOwnPropNames = Object.getOwnPropertyNames;
var __getProtoOf = Object.getPrototypeOf;
var __hasOwnProp = Object.prototype.hasOwnProperty;
var __export = (target, all) => {
  for (var name in all)
    __defProp(target, name, { get: all[name], enumerable: true });
};
var __copyProps = (to, from, except, desc) => {
  if (from && typeof from === "object" || typeof from === "function") {
    for (let key of __getOwnPropNames(from))
      if (!__hasOwnProp.call(to, key) && key !== except)
        __defProp(to, key, { get: () => from[key], enumerable: !(desc = __getOwnPropDesc(from, key)) || desc.enumerable });
  }
  return to;
};
var __reExport = (target, mod, secondTarget) => (__copyProps(target, mod, "default"), secondTarget && __copyProps(secondTarget, mod, "default"));
var __toESM = (mod, isNodeMode, target) => (target = mod != null ? __create(__getProtoOf(mod)) : {}, __copyProps(
  // If the importer is in node compatibility mode or this is not an ESM
  // file that has been converted to a CommonJS file using a Babel-
  // compatible transform (i.e. "__esModule" has not been set), then set
  // "default" to the CommonJS "module.exports" for node compatibility.
  isNodeMode || !mod || !mod.__esModule ? __defProp(target, "default", { value: mod, enumerable: true }) : target,
  mod
));
var __toCommonJS = (mod) => __copyProps(__defProp({}, "__esModule", { value: true }), mod);
var index_native_exports = {};
__export(index_native_exports, {
  AppIcon: () => import_app_icon.AppIcon,
  AppInfo: () => import_app_info.AppInfo,
  AppIntents: () => import_app_intents.AppIntents,
  AppTracking: () => import_app_tracking.AppTracking,
  Audio: () => import_audio.Audio,
  BackgroundTasks: () => import_background_tasks.BackgroundTasks,
  CNContactStore: () => import_contact_ui.CNContactStore,
  CNContactViewController: () => import_contact_ui.CNContactViewController,
  CNMutableContact: () => import_contact_ui.CNMutableContact,
  Calendar: () => import_calendar.Calendar,
  CameraView: () => import_camera.CameraView,
  Compose: () => import_compose.Compose,
  Contacts: () => import_contacts.Contacts,
  ContextMenu: () => ContextMenu,
  DataScannerViewController: () => import_data_scanner.DataScannerViewController,
  Database: () => import_database.Database,
  Device: () => import_device.Device,
  DeviceAttestation: () => import_device_attestation.DeviceAttestation,
  DocumentPicker: () => import_document_picker.DocumentPicker,
  FileSystem: () => import_file_system.FileSystem,
  Haptics: () => import_haptics.Haptics,
  ImageManipulator: () => import_image_manipulator.ImageManipulator,
  ImagePicker: () => import_image_picker.ImagePicker,
  KeepAwake: () => import_keep_awake.KeepAwake,
  LaunchScreen: () => import_launchScreen.LaunchScreen,
  LiveActivities: () => import_widgets.LiveActivities,
  LocalAuthentication: () => import_local_authentication.LocalAuthentication,
  Location: () => import_location.Location,
  MFMailComposeViewController: () => import_message_ui.MFMailComposeViewController,
  MFMessageComposeViewController: () => import_message_ui.MFMessageComposeViewController,
  MapServices: () => import_map_services.MapServices,
  Menu: () => Menu,
  Motion: () => import_motion.Motion,
  Notifications: () => import_notifications.Notifications,
  Open: () => import_open.Open,
  PhotoLibrary: () => import_photo_library.PhotoLibrary,
  Print: () => import_print.Print,
  ProtectedStore: () => import_protected_store.ProtectedStore,
  Purchases: () => import_purchases.Purchases,
  QuickActions: () => import_quick_actions.QuickActions,
  ReservedRegions: () => import_adaptive.ReservedRegions,
  ScreenCapture: () => import_screen_capture.ScreenCapture,
  ScreenOrientation: () => import_screen_orientation.ScreenOrientation,
  Share: () => import_share.Share,
  Storage: () => import_storage.Storage,
  StoreReview: () => import_store_review.StoreReview,
  Swift: () => Swift,
  TextInput: () => import_TextInput.TextInput,
  UI: () => UI,
  VNDocumentCameraViewController: () => import_vision_kit.VNDocumentCameraViewController,
  WidgetUI: () => import_widgets.WidgetUI,
  Widgets: () => import_widgets.Widgets,
  getHinge: () => import_adaptive.getHinge,
  getSizeClass: () => import_adaptive.getSizeClass,
  onHingeChange: () => import_adaptive.onHingeChange,
  useHinge: () => import_adaptive.useHinge,
  useKeepAwake: () => import_keep_awake.useKeepAwake,
  useNativeState: () => import_nativeState.useNativeState,
  usePreventScreenCapture: () => import_screen_capture.usePreventScreenCapture,
  useReservedRegions: () => import_adaptive.useReservedRegions,
  useReservedRegionsReady: () => import_adaptive.useReservedRegionsReady,
  useSizeClass: () => import_adaptive.useSizeClass,
  useSpanning: () => import_adaptive.useSpanning,
  useWindowSegments: () => import_adaptive.useWindowSegments
});
module.exports = __toCommonJS(index_native_exports);
var import_react_native = require("react-native");
var import_unsupported = require("./unsupported");
var import_Containers = require("./Containers.native");
var import_AndroidMenu = require("./AndroidMenu");
var import_Menu = require("./Menu.native");
var import_Pager = require("./Pager.native");
var import_Popover = require("./Popover.native");
var import_NavigationStack = require("./NavigationStack.native");
var import_NavigationSplitView = require("./NavigationSplitView.native");
var import_Sheet = require("./Sheet.native");
var import_ArrangementView = require("./ArrangementView.native");
var import_withAnimation = require("./withAnimation.native");
var import_Animators = require("./Animators.native");
var import_keyframes = require("./keyframes");
var Controls = __toESM(require("./generated/Controls.native"), 1);
var import_mapControls = require("./mapControls.native");
var import_Tabs = require("./Tabs.native");
var import_compose = require("./compose");
var UI = __toESM(require("./effects"), 1);
var import_widgets = require("./widgets/index");
__reExport(index_native_exports, require("./extras"), module.exports);
var import_storage = require("./storage/index.native");
var import_keep_awake = require("./keep-awake/index");
var import_print = require("./print/index");
var import_store_review = require("./store-review/index");
var import_quick_actions = require("./quick-actions/index");
var import_adaptive = require("./adaptive/index.native");
var import_notifications = require("./notifications");
var import_nativeState = require("./nativeState");
var import_TextInput = require("./universal/TextInput/index");
var import_haptics = require("./haptics/index.native");
var import_launchScreen = require("./launchScreen/index.native");
var import_local_authentication = require("./local-authentication/index");
var import_protected_store = require("./protected-store/index");
var import_location = require("./location/index");
var import_file_system = require("./file-system/index.native");
var import_audio = require("./audio/index");
var import_camera = require("./camera/index.native");
var import_share = require("./share/index");
var import_open = require("./open/index.native");
var import_photo_library = require("./photo-library/index");
var import_map_services = require("./map-services/index");
var import_app_tracking = require("./app-tracking/index");
var import_app_icon = require("./app-icon/index");
var import_screen_orientation = require("./screen-orientation/index");
var import_screen_capture = require("./screen-capture/index");
var import_purchases = require("./purchases/index");
var import_image_manipulator = require("./image-manipulator/index.native");
var import_device = require("./device/index");
var import_motion = require("./motion/index.native");
var import_background_tasks = require("./background-tasks/index");
var import_app_intents = require("./app-intents/index");
var import_device_attestation = require("./device-attestation/index");
var import_contacts = require("./contacts/index");
var import_calendar = require("./calendar/index");
var import_app_info = require("./app-info/index.native");
var import_image_picker = require("./image-picker/index.native");
var import_document_picker = require("./document-picker/index.native");
var import_database = require("./database/index.native");
var import_vision_kit = require("./vision-kit/index");
var import_message_ui = require("./message-ui/index");
var import_data_scanner = require("./data-scanner/index");
var import_contact_ui = require("./contact-ui/index");
var Menu = import_react_native.Platform.OS === "android" ? import_AndroidMenu.Menu : import_Menu.Menu;
var ContextMenu = import_react_native.Platform.OS === "android" ? import_AndroidMenu.ContextMenu : import_Menu.ContextMenu;
var Swift = import_react_native.Platform.OS === "ios" ? {
  ArrangementView: import_ArrangementView.ArrangementView,
  Tabs: import_Tabs.Tabs,
  Tab: import_Tabs.Tab,
  TabSection: import_Tabs.TabSection,
  TabViewBottomAccessory: import_Tabs.TabViewBottomAccessory,
  TabViewSlot: import_Tabs.TabViewSlot,
  Menu,
  ContextMenu,
  Sheet: import_Sheet.Sheet,
  FullScreenCover: import_Sheet.FullScreenCover,
  Popover: import_Popover.Popover,
  Host: import_Containers.Host,
  HStack: import_Containers.HStack,
  VStack: import_Containers.VStack,
  ZStack: import_Containers.ZStack,
  Form: import_Containers.Form,
  Section: import_Containers.Section,
  Glass: import_Containers.Glass,
  GlassEffectContainer: import_Containers.GlassEffectContainer,
  GeometryReader: import_Containers.GeometryReader,
  LabeledContent: import_Containers.LabeledContent,
  Button: import_Containers.Button,
  List: import_Containers.List,
  ScrollView: import_Containers.ScrollView,
  ScrollViewReader: import_Containers.ScrollViewReader,
  LazyVStack: import_Containers.LazyVStack,
  LazyHStack: import_Containers.LazyHStack,
  LazyVGrid: import_Containers.LazyVGrid,
  LazyHGrid: import_Containers.LazyHGrid,
  Grid: import_Containers.Grid,
  GridRow: import_Containers.GridRow,
  ControlGroup: import_Containers.ControlGroup,
  DisclosureGroup: import_Containers.DisclosureGroup,
  Divider: import_Containers.Divider,
  Link: import_Containers.Link,
  Group: import_Containers.Group,
  GroupBox: import_Containers.GroupBox,
  ViewThatFits: import_Containers.ViewThatFits,
  Overlay: import_Containers.Overlay,
  ViewSlot: import_Containers.ViewSlot,
  SwipeActions: import_Containers.SwipeActions,
  Pager: import_Pager.Pager,
  Page: import_Pager.Page,
  NavigationStack: import_NavigationStack.NavigationStack,
  NavigationSplitView: import_NavigationSplitView.NavigationSplitView,
  Toolbar: import_NavigationStack.Toolbar,
  ToolbarItem: import_NavigationStack.ToolbarItem,
  ToolbarItemGroup: import_NavigationStack.ToolbarItemGroup,
  ToolbarSpacer: import_NavigationStack.ToolbarSpacer,
  Spacer: import_Containers.Spacer,
  Slot: import_Containers.Slot,
  withAnimation: import_withAnimation.withAnimation,
  PhaseAnimator: import_Animators.PhaseAnimator,
  KeyframeAnimator: import_Animators.KeyframeAnimator,
  KeyframeTrack: import_keyframes.KeyframeTrack,
  LinearKeyframe: import_keyframes.LinearKeyframe,
  SpringKeyframe: import_keyframes.SpringKeyframe,
  CubicKeyframe: import_keyframes.CubicKeyframe,
  MoveKeyframe: import_keyframes.MoveKeyframe,
  ...Controls,
  // the generated map takes no children; the wrapper validates and names
  // the map-controls slot while the native view composes it.
  Map: import_mapControls.Map
} : import_unsupported.Swift;
//# sourceMappingURL=index.native.js.map
